module.exports = __webpack_public_path__ + "6b4cb59efefa0274ca13f35a9f1a34b6.MP3";